import React from "react";

interface CheckmarkIconProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  color?: string;
}

export const PlusIcon: React.FC<CheckmarkIconProps> = ({ className }) => {
  return (
    <svg
    className={className}
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 8.00751L13.5 8.00751"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.49219 2V14"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
